/* ============================================================
   Creator video — swap the poster facade for the real YouTube player.
   Paired with sections/lnx-creator-video.liquid + section-lnx-creator-video.css.

   Nothing from YouTube is requested until this runs, so the section costs one
   image until a visitor actually wants the video.

   The URL carries rel=0 deliberately. Since 2018 that no longer removes the
   end-screen suggestions — it limits them to the same channel — and there is
   no parameter that removes them entirely. Do not add modestbranding: YouTube
   dropped it in 2023 and it is ignored.
   ============================================================ */
(function () {
  function play(root) {
    var id = root.getAttribute('data-lnx-cv-id');
    if (!id || root.dataset.lnxCvPlaying) return;
    root.dataset.lnxCvPlaying = '1';

    var frame = document.createElement('iframe');
    frame.className = 'lnx-cv__frame';
    frame.src =
      'https://www.youtube-nocookie.com/embed/' +
      encodeURIComponent(id) +
      '?rel=0&autoplay=1&playsinline=1';
    frame.title = root.getAttribute('data-lnx-cv-title') || 'YouTube';
    frame.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    frame.setAttribute('loading', 'eager');

    root.innerHTML = '';
    root.appendChild(frame);
    // autoplay is permitted here because the click IS the user gesture.
    try { frame.focus({ preventScroll: true }); } catch (e) {}
  }

  function wire(root) {
    if (root.dataset.lnxCvWired) return;
    var btn = root.querySelector('[data-lnx-cv-play]');
    if (!btn) return;
    root.dataset.lnxCvWired = '1';
    btn.addEventListener('click', function () { play(root); });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-lnx-cv]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor re-renders a section into a fresh DOM node, so re-wire on load.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
